import * as React from 'react';
import c from 'classnames';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { TaxonomyGeneric } from '../../../../types/uncinc_profile/taxonomy';

interface ThemeProps {
  entity: ImmutableEntity<TaxonomyGeneric>;
}

const TaxonomyGenericTitle: React.FC<ThemeProps> = ({
  entity,
  ...props
}) => (
  <h2 className={c('TaxonomyGenericTitle')} {...props}>
    {entity.getIn(['name', 0, 'value'])}
  </h2>
);

export default TaxonomyGenericTitle;
